import { CoreBaseService } from "@core/services/Base.service";

// Reference model
import { PeopleModel } from "@models/PeopleModel";

class PeopleService extends CoreBaseService {
  constructor() {
    super(PeopleModel);
  }

  getTotals() {
    return this.sub("totals").get();
  }

  sendPassword(userId: number) {
    return this.customCall(`send-password/${userId}`).create(null);
  }

  exportInspectors() {
    return this.sub(`export?type=csv`)
      .get(undefined, undefined, true, false, { responseType: "blob" })
      .then((res: any) => {
        res.download("export-inspectors.csv");
      })
      .catch((error) => {
        return error;
      });
  }
}

const inst = new PeopleService();

export default inst;
